/**
 * Environment configuration.
 * CRA requires REACT_APP_ prefix. PRD names VITE_SAI_WEBSITE_URL —
 * both are accepted so deployment can use either naming convention.
 *
 * Canonical API base lives here. Do not construct backend URLs in routes
 * or contexts — import BACKEND_URL / API from this module.
 */
const PRODUCTION_BACKEND_URL = "https://api.debsuntechnologies.com";
const DEVELOPMENT_BACKEND_URL = "http://localhost:8000";

function resolveBackendUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
  if (fromEnv && fromEnv !== "undefined") {
    return fromEnv;
  }
  if (process.env.NODE_ENV === "production") {
    return PRODUCTION_BACKEND_URL;
  }
  return DEVELOPMENT_BACKEND_URL;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const SAI_WEBSITE_URL =
  process.env.REACT_APP_SAI_WEBSITE_URL ||
  process.env.VITE_SAI_WEBSITE_URL ||
  "";

export function getSaiWebsiteUrl() {
  return SAI_WEBSITE_URL.trim();
}

export function hasSaiWebsiteUrl() {
  return Boolean(getSaiWebsiteUrl());
}
